var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12.4997C20 12.9647 19.6231 13.3424 19.1582 13.3425L6.87695 13.3425L11.332 17.7995C11.6356 18.1031 11.6592 18.5805 11.4023 18.9109L11.332 18.99C11.0285 19.2935 10.5511 19.3172 10.2207 19.0603L10.1416 18.99L4.24707 13.0954C3.94351 12.7919 3.91992 12.3145 4.17676 11.9841L4.24707 11.905L10.1416 6.00951C10.4704 5.68106 11.0032 5.68109 11.332 6.00951C11.6356 6.31308 11.6592 6.79147 11.4023 7.12182L11.332 7.20092L6.87598 11.6579L19.1582 11.6579C19.623 11.6581 19.9998 12.0349 20 12.4997Z",
    fill: "#081E56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.25b34e340cf75047e8c14b2cfcece716.svg";
export { ForwardRef as ReactComponent };